<template>
  <!-- AgGrid Table -->
  <div class="category-list">
    <ag-grid-vue
        id="category-list"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table database"
        :columnDefs="columnCategoryDefs"
        :defaultColDef="defaultColDef"
        :rowData="faqBbsCategoryList"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :domLayout="domLayout"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @rowSelected="onSelectRow"
        @sortChanged="onSortChangedEvent"
        :overlayNoRowsTemplate="noRowsTemplate"
        :detailRowAutoHeight="true"
    >
    </ag-grid-vue>
    <div style="position: relative">
      <!-- ITEMS PER PAGE -->
      <div>
        <div class="flex items-center justify-between">
          <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
        </div>
      </div>
      <vs-pagination
          :total="totalPages"
          v-model="currentPage"
          :max="0"
          class="pr-10 pt-10"
      />
    </div>
  </div>
</template>
<script>
import CellRendererActions from '@/components/cell-renderer/CellRendererActions'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import { createNamespacedHelpers } from "vuex";

const faqBbsModule = createNamespacedHelpers('faqBbs')

export default {
  components: {
    AgGridVue
  },
  data() {
    return {

      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      columnCategoryDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 170,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          sort: 'asc',
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'カテゴリ名',
          field: '1',
          filter: true,
          width: 200,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'メモ',
          field: '2',
          filter: true,
          width: 225,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '作成日',
          field: '3',
          filter: true,
          width: 220,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '更新日時',
          field: '4',
          filter: true,
          width: 220,
          unSortIcon: true,
          suppressMovable: true,
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererActions
      }
    }
  },
  computed: {
    ...faqBbsModule.mapGetters(['faqBbsCategoryList', 'totalPages', 'totalRows']),
    currentPage: {
      get () {
        return this.$store.state.faqBbs.faqBbsListModel ? this.$store.state.faqBbs.faqBbsListModel.current_page || 1 : 1
      },
      async set (val) {
        this.pageNumber = val
        await this.fetchFaqBbsList({...this.filterChats, page: this.pageNumber, limit: this.paginationPageSize})
        this.ids = []
        this.gridApi.paginationGoToPage(val-1)
        this.SET_BBS_LIST_CURRENT_PAGE(val)
      }
    },
  },
}
</script>